import React, { Component, Fragment } from 'react';
import { Select, Tooltip, Button } from 'antd';
import { PropTypes } from 'prop-types';
import AddAccountModal from "./AddAccountModal";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

const Option = Select.Option;

class AddAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddAccountModal: false,
        };
    }
    showAddAccountModal = (showAddAccountModal = true) =>
        this.setState({
            showAddAccountModal,
        })
    handleMouseEnter = () => {
        this.setState({color: 'primary'});
    };
    handleMouseLeave = () => {
        this.setState({color: 'initial'});
    };
    render() {
        const { showAddAccountModal } = this.state;
        const { color } = this.state;
        return (
            <Fragment>
                <Tooltip title="Add Account">
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <AddCircleOutlineIcon onClick={this.showAddAccountModal} color={color} onMouseEnter={this.handleMouseEnter}
                                              onMouseLeave={this.handleMouseLeave}/>
                    </div>
                </Tooltip>
                <AddAccountModal visible={showAddAccountModal} showAddAccountModal={this.showAddAccountModal} />
            </Fragment>
        );
    }
}

AddAccount.contextTypes = {
    intl: PropTypes.object.isRequired,
};

export default AddAccount;
